var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignupBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#333333",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1840 4544 c-143 -27 -238 -57 -350 -114 -273 -138 -485 -401 -567 -707 -24 -89 -27 -114 -27 -278 0 -163 3 -189 27 -278 54 -200 159 -378 305 -519 163 -156 334 -246 557 -293 107 -23 303 -23 418 -1 350 67 647 298 798 620 295 630 -54 1367 -731 1546 -68 18 -118 23 -245 25 -88 2 -171 1 -185 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4160 3719 c-28 -11 -86 -64 -103 -94 -8 -13 -14 -112 -17 -295 l-5 -275 -276 -5 c-271 -5 -276 -5 -311 -29 -136 -94 -118 -292 34 -355 31 -13 85 -16 298 -16 l260 0 0 -265 c0 -244 2 -269 20 -304 72 -142 271 -147 351 -8 24 41 24 47 27 310 l3 267 251 0 c282 0 313 5 368 60 95 95 68 261 -52 319 -42 20 -59 21 -306 21 l-262 0 0 254 c0 162 -4 265 -11 287 -30 87 -101 139 -191 138 -29 0 -64 -5 -78 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170 2145 c-646 -109 -1127 -645 -1167 -1300 -8 -145 19 -210 108 -255 38 -20 72 -20 1884 -20 1525 0 1851 2 1878 13 46 20 105 89 113 133 4 21 4 90 1 153 -21 387 -232 773 -556 1017 -169 126 -402 225 -611 259 -127 20 -1530 21 -1650 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupBlack);
export default __webpack_public_path__ + "static/media/SignupBlack.1e861343259ecbf801faa4c03f93cf9a.svg";
export { ForwardRef as ReactComponent };